import { FeatureConfig, TenantConfig } from './tenant-config.model';

/**
 * Fallback local when remote tenant-config is disabled or unreachable.
 * Must stay permissive so non-SPORT tenants are unaffected if the API fails.
 */
export const LOCAL_TENANT_CONFIG: TenantConfig = {
    version: 1,
    defaultRoute: '/app/principal',
    features: {},
    routes: {
        '/login': FeatureConfig.ENABLED,
        '/not-found': FeatureConfig.ENABLED,
        '/app': FeatureConfig.ENABLED,
        '/app/principal': FeatureConfig.ENABLED,
    },
};
